import { NgClass } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DatePickerComponent } from '@com-delta-omnichannel/mach';
import {
  DatePickerError,
  SelectedRange
} from '@com-delta-omnichannel/mach/lib/components/organisms/date-picker/models/date-picker.interfaces';
import { TripTypeOptions } from '../../../constants/book-widget.constants';
import { BookWidgetAem } from '../../../models/book-widget-aem.interfaces';
import { DatepickerConfig } from '../../../models/common.interfaces';
import { ErrorStateDirective } from '../directive';

@Component({
  selector: 'idp-flight-date-picker',
  templateUrl: './flight-date-picker.component.html',
  styleUrls: ['./flight-date-picker.component.scss'],
  standalone: true,
  imports: [DatePickerComponent, ErrorStateDirective, NgClass]
})
export class FlightDatePickerComponent {
  @Input() selectedTripType: TripTypeOptions = TripTypeOptions.ROUND_TRIP;
  @Input() selectedRange: SelectedRange = {} as SelectedRange;
  @Input() bookWidgetAem = {} as BookWidgetAem;
  @Input() datepickerConfig: DatepickerConfig = {} as DatepickerConfig;
  @Input() fieldErrorInfo?: DatePickerError;

  @Output() action = new EventEmitter<SelectedRange>();

  tripTypeOptions = TripTypeOptions;
  isDatePickerOpen = false;

  onDateSelectionChange($event: SelectedRange) {
    this.action.emit($event);
  }

  onDateSelectionClear() {
    this.onDateSelectionChange({ start: null, end: null, total: 0 });
  }

  getSelectedDate() {
    const { departLabel, returnLabel } = this._getAemLabels();

    const start = this._formatDate(this.selectedRange?.start) || departLabel;
    const end = this._formatDate(this.selectedRange?.end) || returnLabel;

    if (this.selectedTripType === TripTypeOptions.ROUND_TRIP) {
      return `${start} - ${end}`;
    }

    return start;
  }

  getAriaLabelSelectedDate(value = '') {
    const { departAriaLabel, returnAriaLabel } = this._getAemLabels();

    const start = `${departAriaLabel} ${this._formatDate(
      this.selectedRange?.start
    )}`;

    const end = `${returnAriaLabel} ${this._formatDate(
      this.selectedRange?.end
    )}`;

    value = value ? value : '';

    if (this.selectedTripType === TripTypeOptions.ROUND_TRIP) {
      return `${value}, ${start} - ${end}`;
    }

    return `${value}, ${start}`;
  }

  private _getAemLabels() {
    const {
      datesField: {
        depart: departLabel = '',
        return: returnLabel = '',
        departAriaLabel: departAriaLabel = '',
        returnAriaLabel: returnAriaLabel = ''
      } = {}
    } = this.bookWidgetAem || {};

    return { departLabel, returnLabel, departAriaLabel, returnAriaLabel };
  }

  private _formatDate(date?: Date | null) {
    if (date) {
      const options: Intl.DateTimeFormatOptions = {
        month: 'short',
        day: 'numeric'
      };
      return new Date(date).toLocaleDateString('en-US', options);
    }
    return '';
  }
}
